/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ContactPersonControllerService } from './services/contact-person-controller.service';
import { CustomerContactControllerService } from './services/customer-contact-controller.service';
import { ContactSalutationControllerService } from './services/contact-salutation-controller.service';
import { ContactSvgRoleControllerService } from './services/contact-svg-role-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ContactPersonControllerService,
    CustomerContactControllerService,
    ContactSalutationControllerService,
    ContactSvgRoleControllerService,
    ApiConfiguration
  ],
})
export class CustomersContactsModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersContactsModule> {
    return {
      ngModule: CustomersContactsModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersContactsModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersContactsModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
